export default __webpack_public_path__ + "static/media/7image.8e6c2884.png";